import $ from 'jquery';
import { showError } from './Errors';

const appointmentChoiceDateTimeForm = $('.js-appointment-choice-date-time-form');

appointmentChoiceDateTimeForm.on('date:fetch-success', () => {
    appointmentChoiceDateTimeForm[0].TurboForm.initInputRequiredListener();
});

appointmentChoiceDateTimeForm.on('date:fetch-error', (e, data) => {
    showError(appointmentChoiceDateTimeForm[0], data.error);
});

appointmentChoiceDateTimeForm.on('date:before-fill-time-list', () => {
    appointmentChoiceDateTimeForm[0].TurboForm.removeInputListener();
    appointmentChoiceDateTimeForm[0].TurboForm.disableSubmitButton();
});
